export const hasError = (name: string, errors: Record<string, string>): boolean => {
    return Object.keys(errors).includes(name);
}

export const getError = (name: string, errors: Record<string, string>) => {
    return errors !== null && typeof errors[name] !== "undefined" ? errors[name] : ''
}
